<template>
  <section class="main">
    <h1 class="heading">{{ $t("REQUESTS") }}</h1>
    <div class="apps">
      <app
        v-for="app in apps"
        :isRequestable="true"
        @request="requestOld(app)"
        type="ios"
        :app="app"
        :key="app.id"
        ref="app"
      />
      <loader v-show="!isLastPage"></loader>
    </div>
    <aside class="notifications">
      <div class="notification">
        <h3 class="notification__heading">{{ $t("REQUEST_FOR_APP") }}</h3>
        <p class="notification__text">
          {{ $t("AUTOMATIC_REQUESTS_TERMS") }}
        </p>
        <router-link
          v-if="!$store.getters.isDeviceLinked"
          class="notification__link"
          to="/link"
        >
          {{ $t("LINK_YOUR_DEVICE") }}
        </router-link>
        <button v-else class="notification__link" @click="requestNew">
          {{ $t("REQUEST_APP_TO_BE_UPLOADED") }}
        </button>
      </div>
    </aside>
  </section>
</template>

<script>
/* eslint-disable no-param-reassign */
import App from '@/components/App';
import Loader from '@/components/Loader';
import { throttle } from 'lodash';

export default {
  components: { App, Loader },
  data() {
    return {
      isLoading: false,
      isLastPage: false,
      page: 1,
      apps: [],
    };
  },
  computed: {
    title() {
      return this.$t('REQUESTS');
    },
  },
  methods: {
    getApps() {
      this.isLoading = true;
      return this.$api.getRequests(this.page).then((data) => {
        data = data.map((app) => {
          if (app.price === '0.00') {
            app.price = 'free';
          } else {
            app.price += ' EUR';
          }

          return app;
        });

        this.apps = [...this.apps, ...data];
        this.isLoading = false;
        if (data.length < 25) {
          this.isLastPage = true;
        }
      });
    },
    requestOld(app) {
      if (app.am_i_requested) {
        return;
      }

      app.am_i_requested = 1;
      app.requesters_amount -= -1;
      this.$api.requestApp(`/app/id${app.trackid}`).catch(() => {
        app.requested = false;
        app.am_i_requested = 0;
        app.requesters_amount -= 1;
      });
    },
    requestNew() {
      this.$prompt(this.$t('COPY_PASTE_APPSTORE_URL')).then((url) => {
        this.$api.requestApp(url).then(() => {
          this.$notify({
            type: 'success',
            text: this.$t('APP_REQUESTED_SUCCESSFULLY'),
          });

          this.apps = [];
          this.page = 1;
          this.getApps();
        });
      });
    },
    // eslint-disable-next-line
    handleScroll: throttle(function () {
      if (this.isLoading || this.isLastPage || !this.$refs.app) {
        return;
      }

      const index = this.apps.length - 20;
      const breakpoint = this.$refs.app[index >= 0 ? index : 0].$el.offsetTop;

      if (window.scrollY > breakpoint) {
        this.page += 1;
        this.getApps();
      }
    }, 1000),
  },
  serverPrefetch() {
    return this.getApps();
  },
  created() {
    this.getApps();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  @include notebook {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 767px) {
    align-items: stretch;
  }
}

.heading {
  display: block;
  width: 100%;
  color: #181f25;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;

  @include notebook {
    text-align: center;
  }

  @media (max-width: 767px) {
    text-align: left;
  }
}

.filters {
  width: 180px;

  @include notebook {
    width: auto;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
}

.apps {
  margin-right: 20px;
  flex-grow: 1;

  @include notebook {
    margin: 30px 0 0;
    order: 1;
  }
}

.notifications {
  flex: 0 0 300px;

  @include notebook {
    flex: 0 0 auto;
    order: 0;
  }
}

.notification {
  background-image: linear-gradient(58deg, #ffecec 0%, #f5f2ff 100%);
  border: 1px solid #faf0ff;
  border-radius: 10px;
  padding: 15px;
  margin: 0;

  &__heading {
    font-size: 20px;
    color: #181f25;
    font-weight: 600;
    margin-bottom: 10px;
  }

  &__text {
    line-height: 20px;
  }

  &__link {
    display: inline-block;
    background: #ffffff;
    border: 1px solid lighten($primary, 35);
    border-radius: 2px;
    color: $primary;
    padding: 7px 10px;
    margin-top: 10px;
  }
}
</style>
